/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    authenticationFormCard: {
      padding: theme.spacing(3.5),
      boxSizing: 'border-box',
      maxWidth: theme.spacing(48),
      width: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    authenticationFormCardContent: {
      width: '100%',
    },
    authenticationFormCardContentEmbedded: {
      width: '100%',
      maxWidth: theme.spacing(32),
    },
    choreoLogo: {},
    choreoSignUpLink: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'default',
    },
    signupCtaSection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    signupDivider: {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
    signupButtonWrapper: {
      width: '100%',
    },
    signupButton: {
      width: '100%',
      minHeight: theme.spacing(6),
      fontFamily: 'Roboto',
      fontWeight: 500,
      fontSize: theme.spacing(1.75),
      lineHeight: `${theme.spacing(3)}px`,
      textTransform: 'none',
      padding: theme.spacing(1.375, 2),
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      border: `1px solid ${theme.palette.common.black}`,
      boxShadow: 'none',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        border: `1px solid ${theme.palette.common.black}`,
        boxShadow: 'none',
      },
    },
    choreMoreDetails: {},
    otherLinks: {
      color: theme.palette.secondary.main,
    },
  })
);
